import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { CardSetTransformationService, CoreService, DataService, DialogResult, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { FORM_IDENTIFIERS, POP_UP_CODES, QUESTION_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { finalize, take } from 'rxjs';
import { ExcelImportService } from '../../services/excel-import.service';
import { DataTable } from '../../interfaces/data-table.interface';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';

@Component({
  selector: 'app-concessions-application-bulk-upload',
  templateUrl: './concessions-application-bulk-upload.component.html',
  styleUrl: './concessions-application-bulk-upload.component.scss'
})
export class ConcessionsApplicationBulkUploadComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.concessionsApplicationBulkUpload;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  isEditing: boolean = false;
  uploadedFile: DataTable[];
  saveEvent: SaveFormEvent;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private excelImportService: ExcelImportService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
      importBulkApplications: (file: File, documentId: string) => this.importBulkApplications(file, documentId),
    };
    this.coreService.conditionFunctions = {};
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationBulkUploadForm.fileName] = FORM_IDENTIFIERS.concessionsBulkUploadFormIdentifier;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    this.saveEvent = event;
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit(false);
  }

  uploadFile() {
    const element = document.getElementById('fileInput') as HTMLElement;
    element.click();
  }

  importBulkApplications(file: File, documentId: string): void {
    this.excelImportService.importBulkApplicationsDataFromXlsx(file, POP_UP_CODES.common.clientError)
      .pipe(take(1))
      .subscribe((data) => {
        this.uploadedFile = data;
      });
  }

  private saveData(request: SaveDataRequest) {
    var saveRequest = {
      ...request,
      uploadedFile: this.uploadedFile
    };
    this.spinnerService.showSpinner();
    if (saveRequest.isSubmit) {
      const endpoint = API_ENDPOINTS.concessionsBulkUploadJob.runConcessionsBulkUploadJob;
      this.registerSubscription(
        this.appDataService.post(endpoint, saveRequest)
          .pipe(
            take(1),
            this.errorService.errorHandler(),
            finalize(() => this.spinnerService.hideSpinner()))
          .subscribe(data => {
            if (data?.status === SAVE_RESULT_STATUS.success) {
              if (POP_UP_CODES.concessionsApplicationBulkUpload.saveBulkUpload.includes(data.message)) {
                this.activeDialog = data.message;
              }
              else {
                this.activeDialog = POP_UP_CODES.common.saveSuccessful;
              }
              this.dialogService.showDialog(this.activeDialog, null, data.details);
            }
          })
      );
    } else {
      this.registerSubscription(
        this.dataService.saveData(API_ENDPOINTS.concessionsApplicationBulkUpload.save, saveRequest)
          .pipe(
            take(1),
            this.errorService.errorHandler(),
            finalize(() => this.spinnerService.hideSpinner())
          )
          .subscribe(data => {
            if (data?.status === SAVE_RESULT_STATUS.success) {
              if (POP_UP_CODES.concessionsApplicationBulkUpload.saveBulkUpload.includes(data.message)) {
                this.activeDialog = data.message;
              }
              else {
                this.id = data.id;
                this.activeDialog = POP_UP_CODES.common.saveSuccessful;
              }
              this.dialogService.showDialog(this.activeDialog, null, data.details);
            }
          })
      );
    }
  }

  dialogButton_allValidContacts_Clicked(event: any): void {
    this.saveEvent.isSubmit = true;
    this.save(this.saveEvent);
  }

  dialogButton_saveSuccessful_Clicked(event: any): void {
    this.exit(true);
  }

  dialogButton_fileAlreadyProcessed_Clicked(event: any): void {
    this.exit( true);
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate(['/', ROUTE_CONSTANTS.concessionsApplicationBulkUploadList.list], ignoreUnsavedChanges);
  }
}
